import script from "./PersonalInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInformation.vue?vue&type=style&index=0&id=6097d549&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6097d549"]])

export default __exports__